import { Component, afterNextRender, inject, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, filter, of } from 'rxjs';
import AOS from 'aos';
import { MenuPrincipalComponent } from './components/menu-principal/menu-principal';
import { FooterComponent } from './components/footer/footer';
import { ConfigSiteService } from './services/config-site.service';

function pathWithoutQuery(url: string): string {
  return url.split('?')[0].split('#')[0];
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MenuPrincipalComponent, FooterComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.scss',
})
export class App {
  private readonly configSiteService = inject(ConfigSiteService);
  private readonly router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);
  private lastPath = pathWithoutQuery(this.router.url);

  readonly config = toSignal(
    this.configSiteService.getConfig().pipe(catchError(() => of(null))),
  );

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const currentPath = pathWithoutQuery(event.urlAfterRedirects);
        if (currentPath !== this.lastPath && isPlatformBrowser(this.platformId)) {
          window.scrollTo(0, 0);
        }
        this.lastPath = currentPath;
      });

    afterNextRender(() => {
      AOS.init({
        duration: 600,
        easing: 'ease-out',
        once: true,
        offset: 80,
      });
      AOS.refresh();
    });
  }
}
